import React, { useEffect, useState } from "react";
// import { IArticle } from "../order/orderDetail";
import ArticleItem from "./ArticleItem";
import { useSelectedArticleStore } from "../../store/store";
import { Article } from "../../api/order/generated/src";

interface IArticleListProps {
    articles: Article[];
    defaultSelected?: string;
}

const ArticleList = (props:IArticleListProps) => {

    const { articles, defaultSelected } = props;

    const [ selectedId, setSelectedId ] = useState<string>(defaultSelected || "");

    const selectedArticle = useSelectedArticleStore(state => state.article);
    const setSelectedArticle = useSelectedArticleStore(state => state.updateSelected);

    useEffect(() => {
        if(defaultSelected){
            setSelectedId(defaultSelected);
        }
        
    }, [defaultSelected]);

    const onSelect = (id:string) => {
        setSelectedId(id);

        setSelectedArticle(id, "");
    };


    const renderItems = () => {
        return props.articles?.map((item, index) => {
            return (
                <ArticleItem 
                    key={index}                
                    article={item}

                    onSelect={onSelect}

                    selected={item.id === selectedId}
                />
            );
        })
    }


    return (
        <div className="w-full mt-4">
            <div className="">
                <div className="w-full">
                    {props.articles && props.articles?.length > 0 && renderItems()}
                </div>
            </div>
        </div>
    )
};

export default ArticleList;
